'use strict';

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _toArray(arr) { return Array.isArray(arr) ? arr : Array.from(arr); }

var first = require('./first');
var getKeys = require('../utils/getKeys');
var identity = require('../functional/identity');
var rest = require('./rest');
var splitWhen = require('./splitWhen');
var type = require('../value/type');

var setup = function setup(item, args) {
  var transform = type(item) === 'object' ? identity : Number;

  var _getKeys = getKeys(item),
      _getKeys2 = _toArray(_getKeys),
      key = _getKeys2[0],
      keys = _getKeys2.slice(1);

  if (args.length) {
    return { transform: transform, keys: [key].concat(_toConsumableArray(keys)), start: first(args) };
  }
  return { transform: transform, keys: keys, start: item[key] };
};

var reduce = function reduce(items, reducer) {
  for (var _len = arguments.length, args = Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
    args[_key - 2] = arguments[_key];
  }

  var _setup = setup(first(items), args),
      keys = _setup.keys,
      transform = _setup.transform,
      start = _setup.start;

  return keys.reduce(function (result, key) {
    var values = items.map(function (item) {
      return item[key];
    });
    return reducer.apply(undefined, [result].concat(_toConsumableArray(values), [transform(key), items[0]]));
  }, start);
};

module.exports = function () {
  for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
    args[_key2] = arguments[_key2];
  }

  var _splitWhen = splitWhen(args, function (arg) {
    return type(arg) === 'function';
  }),
      _splitWhen2 = _slicedToArray(_splitWhen, 2),
      items = _splitWhen2[0],
      remaining = _splitWhen2[1];

  if (getKeys(first(items)).length) {
    return reduce.apply(undefined, [items].concat(_toConsumableArray(remaining)));
  } else if (remaining.length > 1) {
    return remaining[1];
  }
};


//////////////////
// WEBPACK FOOTER
// ./~/fun-util/lib/iterable/reduce.js
// module id = 415
// module chunks = 37